const Footer = () => {
  return (
    <footer className="bg-[#fdf6ee] text-black px-6 py-12 text-sm border-t border-gray-200 w-full">
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
        <div>
          <h4 className="font-semibold mb-3">Company</h4>
          <ul className="space-y-2">
            <li>
              <a href="/become-partner" className="hover:underline">
                Become a Partner
              </a>
            </li>
            <li>
              <a href="/platform" className="hover:underline">
                Platform Overview
              </a>
            </li>
            <li>
              <a href="/careers" className="hover:underline">
                Careers
              </a>
            </li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold mb-3">Resources</h4>
          <ul className="space-y-2">
            <li>
              <a href="/faq" className="hover:underline">
                FAQs
              </a>
            </li>
            <li>
              <a href="/support" className="hover:underline">
                Support
              </a>
            </li>
            <li>
              <a href="/terms" className="hover:underline">
                Terms of Service
              </a>
            </li>
            <li>
              <a href="/privacy" className="hover:underline">
                Privacy Policy
              </a>
            </li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold mb-3">Contact</h4>
          <ul className="space-y-2">
            <li>Email: support@fullplatenow.com</li>
            <li>Phone: (702) 983-4245</li>
            <li>Monday–Friday, 9am–6pm PST</li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold mb-3">Get the App</h4>
          <div className="flex gap-2 mt-2">
            <button className="bg-gray-100 text-black px-4 py-2 rounded-full text-sm hover:bg-gray-200 transition">
               iPhone
            </button>
            <button className="bg-gray-100 text-black px-4 py-2 rounded-full text-sm hover:bg-gray-200 transition">
              🤖 Android
            </button>
          </div>
        </div>
      </div>

      <div className="text-center text-xs mt-10 text-black/50">
        © {new Date().getFullYear()} FullPlateNow. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
